import {FC, MouseEvent, useState} from 'react';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import {IContactPersonToSubmit} from '../../../../../../../shared/types/person.types';

import {getFullName} from '../../../../../../../shared/helpers/getFullName';

import {colors} from '../../../../../../../shared/colors';
import {Table, TableBody, TableHead} from '@mui/material';

interface IContactPersonRow {
  row: IContactPersonToSubmit;
  handleClickEdit: (e: MouseEvent<HTMLTableRowElement | HTMLButtonElement>) => void;
  handleClickDelete: (e: MouseEvent<HTMLTableRowElement | HTMLButtonElement>) => void;
}

export const ContactPersonRow: FC<IContactPersonRow> = ({row, handleClickDelete, handleClickEdit}) => {
  const [open, setOpen] = useState(false);

  const toggleCollapse = (e: MouseEvent<HTMLTableRowElement | HTMLButtonElement>) => {
    e.stopPropagation();

    setOpen(!open);
  };

  return (
    <>
      <TableRow onClick={toggleCollapse} hover sx={{cursor: 'pointer'}} selected={open}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={toggleCollapse}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="left">{getFullName(row)}</TableCell>
        <TableCell align="left">{row.phoneNumber}</TableCell>
        <TableCell align="left">{row.email}</TableCell>
        <TableCell align="left">{row.birthDate}</TableCell>
        <TableCell align="left">
          <Tooltip title="Изменить">
            <IconButton onClick={handleClickEdit}>
              <ModeEditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Удалить">
            <IconButton onClick={handleClickDelete}>
              <DeleteForeverIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
      <TableRow sx={{backgroundColor: colors['bg--on-white']}}>
        <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{fontWeight: 'bold'}} align="center">
                    Должность
                  </TableCell>
                  <TableCell sx={{fontWeight: 'bold'}} align="center">
                    Зона ответственности
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{row.relationTitle}</TableCell>
                  <TableCell>{row.description}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
